import axios from "axios";
import { apiRoot } from "@/config";

export const getUser = async () => await axios.get(`${apiRoot}/user`);
export const updateUserPinned = async pinned => await axios.post(`${apiRoot}/user/pinned`, { pinned });
export const updateUserTrelloKey = async key => await axios.post(`${apiRoot}/user/trello-key`, { key });